import moment from 'moment';
import api from '../../../api';
import map from '../../map';
import environment from '../../../environment';

export const storeExportType = {
    Dealerships: 1,
    Competitors: 2,
    StoreInactive: 3,
    Points: 4,
    UnapprovedStores: 5,
    StoresMotocycle: 6,
    StorePlanned: 7,
    StoresConsortium: 8,
};

export const storeNameToExcel = {
    Rede: 1,
    Concorrentes: 2,
    StoreInactive: 3,
    Points: 4,
    LojasNaoHomologadas: 5,
    ["Rede Motos"]: 6,
    LojasPlanejadas: 7,
    ["Rede Consórcio"]: 8,
};

export const storeExportTypeNames = Object.keys(storeExportType).reduce((acc, curr) => {
    acc[storeExportType[curr]] = curr;
    return acc;
}, {});

export const storeNameToExcelNames = Object.keys(storeNameToExcel).reduce((acc, curr) => {
    acc[storeNameToExcel[curr]] = curr;
    return acc;
}, {});

export const exportStore = (storeExportType) => {
    const payload = {
        fileName: `${environment.get('CONFIG.CLIENT')}_${storeNameToExcelNames[storeExportType]}_Ficha da Loja_${moment().format('YYYYMMDD')}.csv`,
        bbox: map.getCurrentBbox(),
        exportType: storeExportType,
    };
    return api.store.post.export(payload);
};



// WEBPACK FOOTER //
// ./src/scripts/core/export/store/index.js